var integers = require('integers');

module.exports = function linspace(a,b,n) {
  var every = (b-a)/(n-1),
      ranged = integers(a,b,every);

  return ranged.length == n ? ranged : ranged.concat(b);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/linspace/index.js
// module id = KSh1
// module chunks = 0